export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "The lecturer presented and repeated the content appropriately.",
			},
			{
				id: 3,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 4,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 5,
				text: "The lecturer provided the opportunity to ask questions.",
			},
			{
				id: 6,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 7,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 8,
				text: "It was important to the lecturer that the par,cipants benefi.ed from the course.",
			},
			{
				id: 9,
				text: "The lecturer taught the contents of the course in an interesting way.",
			},
			{
				id: 10,
				text: "The materials and the media used by the lecturer were very helpful.",
			},
			{
				id: 11,
				text: "The range of support offered by the lecturer (e.g. office hours) was adequate.",
			},
			{
				id: 12,
				text: "The learning objective was clear to me.",
			},
			{
				id: 13,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 14,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 15,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 16,
				text: "I learned important facts in the course.",
			},
			{
				id: 17,
				text: "I further developed important competencies in the course.",
			},
			{
				id: 18,
				text: "The competencies acquired in the course are of great relevance for my individual development.",
			},
			{
				id: 19,
				text: "The course's topic is relevant for my future career.",
			},
			{
				id: 20,
				text: "The difficulty of the contents was adequate.",
			},
			{
				id: 21,
				text: "The amount of the content was adequate.",
			},
			{
				id: 22,
				text: "The pace of the course was adequate.",
			},
			{
				id: 23,
				text: "The requirements of the course were adequate.",
			},
			{
				id: 24,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 25,
				text: "The course was too difficult for me.",
			},
			{
				id: 26,
				text: "I put a lot of time into the preparation and follow-up work of the course.",
			},
			{
				id: 27,
				text: "I prepared the texts/materials of the course regularly.",
			},
			{
				id: 28,
				text: "On my own initiative, I read literature related to the content of the course.",
			},
			{
				id: 29,
				text: "I put more time into this course than into comparable courses.",
			},
			{
				id: 30,
				text: "I participated in the course actively.",
			},
			{
				id: 31,
				text: "The tutorial deepened my understanding of the contents.",
			},
			{
				id: 32,
				text: "The tutorial inspired me to reflect the contents we discussed.",
			},
			{
				id: 33,
				text: "The content of the tutorial was clarified through examples.",
			},
			{
				id: 34,
				text: "During the tutorial, theory and practical application were put into relation to each other.",
			},
			{
				id: 35,
				text: "The tutorial provided an opportunity to actively practice my language skills.",
			},
			{
				id: 36,
				text: "I improved my language competencies due to the tutorial.",
			},
			{
				id: 37,
				text: "I received feedback on my language competencies throughout the tutorial.",
			},
			{
				id: 38,
				text: "There was ample opportunity for interaction with the lecturer through the online tools.",
			},
			{
				id: 39,
				text: "There was ample opportunity for interaction with the other students through the online tools.",
			},
			{
				id: 40,
				text: "The online appointments were well organized.",
			},
			{
				id: 41,
				text: "The online materials (e.g. texts, quizzes, videos, etc.) contributed significantly to the understanding of the learning content.",
			},
			{
				id: 42,
				text: "The possibilities of digital teaching beyond traditional teaching (discussion forums, interactive assignments, etc.) were well used.",
			},
			{
				id: 43,
				text: "Overall, the digital elements of the event were good.",
			},
			{
				id: 44,
				text: "The course is an example of good digital education.",
			},
			{
				id: 45,
				text: "Overall, this was a good course.",
			},
			{
				id: 46,
				text: "I learned a lot in this course.",
			},
			{
				id: 47,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 48,
				text: "I would recommend the course.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 49,
				text: "Further remarks regarding the course (praise/criticism)",
			},
		],
	},
];
